class LTAFaqsSearch extends HTMLElement {
	constructor() {
		super()

		this.data = {
			searchQuery: '',
		}

		this.handleSearchInput = this.handleSearchInput.bind(this)
	}

	connectedCallback() {
		// Cache DOM elements
		this.searchInputEl = this.querySelector('[data-search-input]')
		this.faqEls = this.querySelectorAll('l-collapsible-tab')
		this.categoryEls = this.querySelectorAll('[data-category-title]')
		this.bindEvents()
	}

	bindEvents() {
		if (this.searchInputEl) {
			this.searchInputEl.addEventListener('input', l_debounce(this.handleSearchInput, 300))
		}
	}

	handleSearchInput() {
		this.data.searchQuery = (this.searchInputEl?.value ?? '').trim().toLowerCase()
		this.updateFAQDisplay()
	}

	updateFAQDisplay() {
		const searchQuery = this.data.searchQuery
		const isSearching = !!searchQuery
		this.classList.toggle('is-searching', isSearching)

		// Show/hide each FAQ
		this.faqEls.forEach((faqEl) => {
			const questionText = faqEl.querySelector('[data-question-label]')?.textContent.trim().toLowerCase() || ''
			const answerText = faqEl.querySelector('[data-answer]')?.textContent.trim().toLowerCase() || ''
			const matchesQuery = isSearching ? questionText.includes(searchQuery) || answerText.includes(searchQuery) : true
			faqEl.classList.toggle('l-hidden', !matchesQuery)
		})

		// Show/hide each category
		let activeGroupCount = 0
		this.categoryEls.forEach((categoryEl) => {
			const categoryName = categoryEl.dataset.categoryTitle
			const hasVisibleFAQ = Array.from(this.faqEls).some(
				(faqEl) => !faqEl.classList.contains('l-hidden') && faqEl.dataset.category === categoryName
			)
			categoryEl.classList.toggle('l-hidden', !hasVisibleFAQ)
			const parent = categoryEl.parentElement
			if (parent) {
				parent.classList.toggle('l-hidden', !hasVisibleFAQ)
				parent.classList.toggle('is-first-child', hasVisibleFAQ && activeGroupCount === 0)
			}
			if (hasVisibleFAQ) activeGroupCount++
		})

		this.classList.toggle('is-empty', activeGroupCount === 0)
		this.dataset.activeGroupCount = activeGroupCount
	}
}

customElements.define('l-faqs-search', LTAFaqsSearch)

